/**
 * US states that prohibit insurers from depreciating labor on structural
 * (e.g. roof) claims. Informational, not legal advice.
 */
export const LABOR_DEPRECIATION_PROHIBITED_STATES: { code: string; name: string }[] = [
  { code: "AZ", name: "Arizona" },
  { code: "AR", name: "Arkansas" },
  { code: "CA", name: "California" },
  { code: "CT", name: "Connecticut" },
  { code: "IL", name: "Illinois" },
  { code: "KY", name: "Kentucky" },
  { code: "MD", name: "Maryland" },
  { code: "MS", name: "Mississippi" },
  { code: "MO", name: "Missouri" },
  { code: "OH", name: "Ohio" },
  { code: "TN", name: "Tennessee" },
  { code: "TX", name: "Texas" },
  { code: "UT", name: "Utah" },
  { code: "VT", name: "Vermont" },
  { code: "WA", name: "Washington" },
  { code: "WI", name: "Wisconsin" },
];
